<div class="w-full flex flex-col gap-4 p-4">
    <p-card [header]="'Categorias'">
        <div class="w-full flex flex-col gap-4">
            <app-input-search
                [(ngModel)]="textoPesquisa"
                [placeholder]="'Digite parte do nome do produto, código de barras ou código interno'"
                (search)="carregarLista(0)"
                class="w-full md:max-w-90"
            ></app-input-search>

            <p-table
                [paginator]="true"
                [(rows)]="qtdLinhas"
                [totalRecords]="totalItens"
                [value]="lista"
                [lazy]="true"
                (onLazyLoad)="lazyLoad($event)"
                [rowsPerPageOptions]="[100, 200, 300, 400, 500, 1000]"
                dataKey="Id"
            >
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th class="w-[3%] min-w-10">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th class="w-[92%] min-w-30">Descrição</th>
                        <th class="w-[5%] min-w-10">Ações</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr [pSelectableRow]="rowData">
                        <td>
                            <p-tableCheckbox
                                [value]="rowData"
                            ></p-tableCheckbox>
                        </td>
                        <!-- o valor que aparece aqui é o nome, não tem descrição na API -->
                        <td>{{ rowData.Nome }}</td>
                        <td>
                            <app-opcoes-table
                                [value]="rowData"
                                [opcoes]="opcoesTable"
                            ></app-opcoes-table>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<p-confirmDialog
    header="Confirmacao"
    icon="pi pi-exclamation-triangle"
    styleClass="max-w-[90%]"
></p-confirmDialog>
